import store, { rootReducer } from "../../../store";
import {
  setAuth,
  setCredentialError,
  setEnterpriseId,
  setIsFirstLogin,
  setOrgId,
  setOrganizationId,
  setOrganizationType,
  setUserInformation,
} from "../../../slices/common/reducer";
import { sidebarList } from "../../../Utils/CommonService";
import { setSelectedUser } from "../../../slices/header/headerSlice";
import { showToast } from "../../../common/Toaster/Toaster";
import api from "../../../Utils/interface";

const GCM_TAG_LENGTH = 16;

const strToArrayBuffer = (str) => new TextEncoder().encode(str);

const arrayBufferToBase64 = (buffer) => {
  const byteArray = new Uint8Array(buffer);
  return base64js.fromByteArray(byteArray);
};

const encrypt = async (plaintext, key, iv) => {
  const keyBuffer = strToArrayBuffer(key);
  const ivBuffer = strToArrayBuffer(iv);
  const plaintextBuffer = strToArrayBuffer(plaintext);

  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    keyBuffer,
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const encryptedBuffer = await window.crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: ivBuffer,
      tagLength: GCM_TAG_LENGTH * 8,
    },
    cryptoKey,
    plaintextBuffer
  );

  return arrayBufferToBase64(encryptedBuffer);
};

const masterKey = "7x!A%D*G-JaNdRgUkXp2s5v8y/B?E(H+";
const masterIV = "ABCDEFGHIJKLMNOP";

export const callbackUser = (username, code, isCustomer, nav) => {
  const fd = new FormData();
  fd.append("emailId", username);
  fd.append("password", code);
  fd.append("isCustomer", isCustomer);

  api
    .post(`/useraccount/authenticate`, fd)
    .then((response) => {
      if (response.status === 200) {
        const token = response.data.jwt;
        const username = response.data.loggedInUser.emailid;
        const name = response.data.loggedInUser.name;
        const organizationId = response.data.loggedInUser.organizationid;
        const enterpriseId = response.data.loggedInUser.enterpriseid;
        const userId = response.data.loggedInUser.entityid;
        const organizationType =
          response.data.loggedInUser.user_org_mapping_list[0].organization_type;
        localStorage.setItem("token", token);
        localStorage.setItem("username", username);
        localStorage.setItem("name", name);
        localStorage.setItem("organizationId", organizationId);
        localStorage.setItem("enterpriseid", enterpriseId);
        localStorage.setItem("organizationType", organizationType);
        localStorage.setItem("userId", userId);

        if (token) store.dispatch(setAuth(true));
        store.dispatch(
          setUserInformation(response.data.loggedInUser.organizationid)
        );

        store.dispatch(
          setOrganizationType(
            response.data.loggedInUser.user_org_mapping_list[0]
              .organization_type
          )
        );
        store.dispatch(
          setOrganizationId(response.data.loggedInUser.organizationid)
        );
        store.dispatch(setOrgId(response.data.loggedInUser.organizationid));
        store.dispatch(setIsFirstLogin(response.data.isFirstLogin));
        // rootReducer.dispatch(
        //   setEnterpriseId(response.data.loggedInUser.enterpriseid)
        // );
        sidebarList(response.data.loggedInUser.organizationid);
        // if (response.data.isFirstLogin) {
        //   nav("/reset");
        // } else {
        nav("/hub/information");
        // }

        sidebarList(response.data.loggedInUser.organizationid);
      }
      // showToast("Login successful!", "success");
    })
    .catch((err) => {
      console.log(err);
      store.dispatch(setCredentialError(err?.response?.data?.error_message));
      // showToast("Error while login", "error");
    });
};

export const logoutUser = (nav) => {
  api
    .post(`/v1/logoutApi`)
    .then(() => {
      localStorage.clear();
      // localStorage.removeItem("token");
      // localStorage.removeItem("organizationId");
      // localStorage.removeItem("organizationType");
      // localStorage.removeItem('selectedUser');
      // localStorage.removeItem('username');
      // localStorage.removeItem('i18nextLng');
      // localStorage.removeItem('I18N_LANGUAGE');
      store.dispatch(setAuth(false));
      store.dispatch(setSelectedUser(""));
      store.dispatch(setUserInformation(null));
      nav("/");
      // showToast("Logout Successfully!", "success");
    })
    .catch((error) => {
      // nav("/");
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      sessionStorage.removeItem("selectedModule");
      store.dispatch(setAuth(false));
      console.log(error);
      showToast("Error while logout!", "error");
    });
};
